package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CalendarEventPublicResponse(
    val id: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("academic_year_id") val academicYearId: String? = null,
    @SerialName("event_date") val eventDate: String? = null,
    @SerialName("is_all_day") val isAllDay: Boolean? = null,
    @SerialName("from_time") val fromTime: String? = null,
    @SerialName("to_time") val toTime: String? = null,
    @SerialName("event_title") val eventTitle: String? = null,
    @SerialName("event_type") val eventType: String? = null,
    @SerialName("applicable_to") val applicableTo: String? = null,
    val status: String? = null,
    @SerialName("is_weekly_holiday") val isWeeklyHoliday: Boolean? = null
)
